import React from "react";
import "../../css/Footer.css";
import { ReactComponent as PhoneIcon } from "../../assets/icons/contact.svg";
import { ReactComponent as LocationIcon } from "../../assets/icons/location.svg";
import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg";
import { Link, useNavigate } from "react-router-dom";

import { ReactComponent as LinkedIcon } from "../../assets/icons/linkedin.svg";

function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      {/* Contact Footer */}
      <div className="footer-contact-section">
        <div className="footer-contact-info">
          <div className="footer-contact-item">
            <div className="footer-contact-details">
              <Link
                to="/privacy-policy"
                className="content-large footer-contact-value"
                style={{ textDecoration: "underline" }}
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-social-section">
        <Link
          to="tel:+4407557338347"
          target="_blank"
          className="footer-social-link"
        >
          <PhoneIcon className="footer-contact-icon" />
        </Link>
        <Link
          to="mailto:morris@foundationsfp.com"
          target="_blank"
          className="footer-social-link"
        >
          <EmailIcon className="footer-contact-icon" />
        </Link>
        <Link
          to="https://www.google.com/maps/place/10+Flint+Ln,+Barrow+upon+Soar,+Loughborough+LE12+8YG/@52.758757,-1.1517271,17z/data=!3m1!4b1!4m5!3m4!1s0x4879de5c4aa04bcd:0xc20b25c74bb8c37b!8m2!3d52.7587538!4d-1.1491522?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          className="footer-social-link"
        >
          <LocationIcon className="footer-contact-icon" />
        </Link>

        <Link
          to="https://www.linkedin.com/authwall?trkInfo=AQF8Qf95mJc1_AAAAZz2A6FYmv5_JrsXqRKT_fumfKykbLoYsugk5DZU4b-PybilTYEmGGqM-mRr1QSPYngGAbHXzPImyfbJAs1D5EDTP_Pqt8CrNfflNUYqzI4vOMGUXT9HScs=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Ffoundations-financial-planning-ffp"
          target="_blank"
          className="footer-social-link"
        >
          <LinkedIcon className="footer-contact-icon" />
        </Link>
      </div>

      {/* Legal Footer */}
      <div className="content-tiny footer-legal">
        <p>
          Foundations Financial Planning Ltd is an Appointed Representative of
          Rosemount Financial Solutions (IFA) Ltd which is authorised and
          regulated by the Financial Conduct Authority. Entered on the FCA
          Register (https://register.fca.org.uk/) under reference 535515.
        </p>
        <p>
          Foundations Financial Planning Ltd is registered as a Company in
          England & Wales No. 16423362 Registered Address: 10 Flint Lane, Barrow
          Upon Soar, Loughborough, Leicestershire, LE12 8GS.
        </p>
        <p>
          The information contained within this website is subject to the UK
          regulatory regime, and is therefore targeted at consumers based in the
          UK.
        </p>
        <p>
          When clicking any external links you will be departing from the
          regulatory site of Foundations Financial Planning Ltd. Neither
          Foundations Financial Planning Ltd Nor Rosemount Financial Solutions
          (IFA) Ltd are responsible for the accuracy of the information
          contained within the linked site.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
